module.exports = __webpack_public_path__ + "img/bg4.f1907dc5.png";